export default "__VITE_ASSET__B4yTRyle__"